/*受理+派单*/
export function startHandleAndPaiDan(data = {}) {
    return abp.ajax({
        url: '/api/services/app/MicroWorkOrder/StartHandleAndPaiDan',
        method: 'post',
        data: data
    });
}

/*获取楼栋维修相关人员*/
export function getBuildingRepairer(workOrderId) {
    return abp.ajax({
        url: '/api/services/app/WorkOrder/GetBuildingRepairer',
        method: 'get',
        params: {workOrderId: workOrderId}
    });
}

/*未派单 工单*/
export function getNotPaiDanWorkOrders(data = {}) {
    return abp.ajax({
        url: '/api/services/app/MicroWorkOrder/GetNotPaiDanWorkOrders',
        method: 'get',
        params: data
    });
}

/*工单任务*/
export function getWorkOrderTasks(data = {}) {
    return abp.ajax({
        url: '/api/services/app/MicroWorkOrder/GetWorkOrderTasks',
        method: 'get',
        params: data
    });
}
/*报修 已派单 未派工*/
export function getNotPaiGongWorkOrders(data = {}) {
    return abp.ajax({
        url: '/api/services/app/MicroWorkOrder/GetNotPaiGongWorkOrders',
        method: 'get',
        params: data
    });
}
/*报修 已派单 已派工*/
export function getPaiGongWorkOrders(data = {}) {
    return abp.ajax({
        url: '/api/services/app/MicroWorkOrder/GetPaiGongWorkOrders',
        method: 'get',
        params: data
    });
}

/*待回访*/
export function getNoReturnVisit(data = {}) {
    return abp.ajax({
        url: '/api/services/app/MicroWorkOrder/GetNoReturnVisit',
        method: 'get',
        params: data
    });
}

/*拆分工单*/
export function saveSplitWorkOrders(data = {}) {
    return abp.ajax({
        url: '/api/services/app/MicroWorkOrder/SaveSplitWorkOrders',
        method: 'post',
        data: data
    });
}


